import { get, put } from "@/services/api";

export const ConfiguracionGlobal = {
  state: () => ({
    config: null,
  }),
  mutations: {
    setConfig(state, newValue) {
      state.config = newValue;
    },
  },
  actions: {
    getConfig({ commit }) {
      get("/configuraciones/1")
        .then((data) => {
          commit("setConfig", data?.data?.data);
        })
        .catch((err) => {
          commit("setConfig", null);
        });
    },
    updateConfig(_, data) {
      const { costo_envio, minimo_envio_gratis, ...stripped } = data;
      return new Promise((res, rej) => {
        put("/configuraciones/1", {
          data: {
            ...stripped,
            costo_envio: isNaN(Number(costo_envio))
              ? null
              : Number(costo_envio),
            minimo_envio_gratis: isNaN(Number(minimo_envio_gratis))
              ? null
              : Number(minimo_envio_gratis),
          },
        })
          .then((success) => {
            res("Configuración actualizada");
          })
          .catch((err) => {
            console.error(error);
            rej("No se pudo actualizar la configuración, inténtelo nuevamente");
          });
      });
    },
  },
};
